
import $ from "jquery"
import "jquery-shorten"


import I18n from "plugins/i18n-js"


// Too trivial to make it a new file, nor is it possibly used by other pages.
// Let"s leave it here.
function init() {
  $(".page-section--service-apartment-provider-block__content__description")
  .shorten({
    showChars:  1000,
    moreText:   I18n.t("js.jquery_shorten.see_more"),
    lessText:   I18n.t("js.jquery_shorten.see_less"),
  })
}


export default {
  init,
}


